import { Timeline } from '@mui/icons-material';
import { CostRadarTrialManager } from '../modules/cost-radar-trial/CostRadarTrialManager';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const CostRadarTrial: RouteType = {
  exact: true,
  path: routePaths.costRadarTrial,
  title: 'Cost Radar Trial',
  icon: Timeline,
  component: () => <CostRadarTrialManager />,
  permission: 'canModifyCostRadarTrial',
};

export default CostRadarTrial;
